import React from "react";
import { Link } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { t } from "../lib/i18n";

export default function VerseCard({ verse }) {
  const { lang } = useApp();
  if (!verse) return null;
  const clean = (verse.text || "").trim().replace(/^["“”'']+|["“”'']+$/g, "");
  return (
    <Link
      to={`/read/${verse.bookId}/${verse.chapter}`}
      className="block glass rounded-3xl p-7 md:p-9 group hover:-translate-y-1 transition-transform duration-300"
    >
      <div className="flex items-center gap-2 mb-4">
        <span className="h-px w-6 bg-[var(--gold)]" />
        <span className="text-[0.7rem] font-semibold tracking-[0.2em] uppercase text-[var(--gold-deep)]">
          {t(lang, "todaysVerse")}
        </span>
      </div>
      <p className="font-scripture text-2xl md:text-[1.75rem] leading-relaxed text-[var(--ink)] group-hover:text-[var(--gold-deep)] transition-colors">
        “{clean}”
      </p>
      <p className="mt-4 text-sm font-medium text-[var(--ink-faint)]">— {verse.ref}</p>
    </Link>
  );
}
